/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import getComponentName from 'react-utils/getComponentName';
import { ComponentCSSManager } from 'react-codemirror/util/LoadCSS';
import { refresh } from 'react-codemirror/util/Editor';

/**
 * Creates a simple pubsub so multiple editors can listen to a single request.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function createPubSub() {
  const listeners = new Map();
  let fired = false;
  return {
    on(context, fn) {
      if (fired) return;
      listeners.set(context, fn);
    },
    off(context) {
      listeners.delete(context);
    },
    fire() {
      fired = true;
      listeners.forEach((fn, context) => fn.call(context));
      listeners.clear();
    }
  };
}

/**
 * The outer closure should only be used once per component definition
 * not per component instance.
 *
 * @param {Array} loads
 */
export default function loadCSS(loads = []) {
  const cssManager = new ComponentCSSManager(loads);
  let isResolved = false;
  const pubsub = createPubSub();
  return function withLoadCSS(CodemirrorComponent) {
    var _class;
    return _class = class WithLoadCSS extends Component {
      constructor(props) {
        super(props);
        this.refCodemirror = ref => {
          const codemirror = ref && ref.codemirror;
          if (this.codemirror === codemirror) return;
          this.codemirror = codemirror;
          if (this.props.refCodemirror) {
            this.props.refCodemirror(ref);
          }
        };
        pubsub.on(this, this.refresh);
        this.fetchCss(props);
      }
      componentDidUpdate(prevProps) {
        if (this.props.useDynamicCssLoading !== prevProps.useDynamicCssLoading || this.props.refCodemirror !== prevProps.refCodemirror) {
          this.fetchCss(this.props);
        }
      }
      componentWillUnmount() {
        pubsub.off(this);
      }
      fetchCss(props) {
        if (isResolved || !props.useDynamicCssLoading || cssManager.isFetching) {
          return;
        }
        cssManager.fetch().then(() => {
          isResolved = true;
          pubsub.fire();
        }, () => {});
      }
      refresh() {
        refresh(this.codemirror);
      }
      render() {
        return /*#__PURE__*/_jsx(CodemirrorComponent, Object.assign({}, this.props, {
          refCodemirror: this.refCodemirror
        }));
      }
    }, _class.propTypes = {
      refCodemirror: PropTypes.func,
      /**
       * If `true` required CSS will by fetched dynamically. Default is `false`.
       * Global feature: any one editor instance can trigger but CSS will apply to all instances.
       * @type {Boolean}
       */
      useDynamicCssLoading: PropTypes.bool
    }, _class.defaultProps = {
      useDynamicCssLoading: false
    }, _class.displayName = `WithLoadCSS(${getComponentName(CodemirrorComponent)})`, _class;
  };
}